import React from 'react';
import { DomainPage } from './components/DomainPage';

import './index.scss';

export default function Domains() {
  return <DomainPage />;
}
